import React, { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import { getResourceTo } from 'react/utils/utils';
import IntegrationCard from './IntegrationCard';

function WGLNIntegrationCard() {
  const id = useMemo(() => uuid(), []);

  return (
    <IntegrationCard
      id={id}
      cardName={'wGLN'}
      isConfigurable={false}
      active
      infoText="wglnIntegration.card.helpText"
    >
      <div data-testid={`integration-description-${id}`} className="IntegrationDescription">
        <span>
          {getResourceTo('wglnIntegration.card.description')}
        </span>
      </div>
      <div data-testid={`view-logs-${id}`} className="ViewLogs">
        <Link data-testid={`view-logs-link-${id}`} to={`/Integrations/wgln/logs`}>
          <span>{getResourceTo('IntegrationCard.ViewLogsButton')}</span>
        </Link>
      </div>
    </IntegrationCard>
  );
}

export default memo(WGLNIntegrationCard);
